module.exports = __webpack_public_path__ + "img/SketchPngf3940c4145cbfb2d91e9795c1942450ce5ade0fdde586f432ad55a58411e75a9.8e54ea74.png";